var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon2Ar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.8082 2.38128C8.8082 1.98679 8.4884 1.66699 8.0939 1.66699H2.3796C1.9852 1.66699 1.6654 1.98679 1.6654 2.38128V8.09556C1.6654 8.49005 1.9852 8.80985 2.3796 8.80985C2.7741 8.80985 3.0939 8.49005 3.0939 8.09556V4.10572L11.3984 12.4102C11.6773 12.6891 12.1296 12.6891 12.4085 12.4102C12.6875 12.1312 12.6875 11.679 12.4085 11.4L4.1041 3.09556H8.0939C8.4884 3.09556 8.8082 2.77577 8.8082 2.38128ZM15.713 5.00033C16.3705 5.00033 16.9035 5.53332 16.9035 6.1908V15.7146C16.9035 16.3721 16.3705 16.9051 15.713 16.9051H6.1892C5.5317 16.9051 4.9987 16.3721 4.9987 15.7146V11.9051C4.9987 11.5106 4.6789 11.1908 4.2844 11.1908C3.8899 11.1908 3.5701 11.5106 3.5701 11.9051V15.7146C3.5701 17.1611 4.7427 18.3337 6.1892 18.3337H15.713C17.1594 18.3337 18.332 17.1611 18.332 15.7146V6.1908C18.332 4.74434 17.1594 3.57175 15.713 3.57175H11.9035C11.509 3.57175 11.1892 3.89155 11.1892 4.28604C11.1892 4.68053 11.509 5.00033 11.9035 5.00033H15.713Z",
    fill: "#D53E20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon2Ar);
export default __webpack_public_path__ + "static/media/link-icon-2-ar.5f9e335ed6eb0d2bdc17304a5990d598.svg";
export { ForwardRef as ReactComponent };